// extracted by mini-css-extract-plugin
module.exports = {"form":"contact_form__f2-j8","input":"contact_input__2d7h_","submit":"contact_submit__2Mi85","darkMode":"contact_darkMode__1tAzk","textarea":"contact_textarea__1UDIW"};